
// track an event
const trackEvent = (eventName, props) => {
  // GA
  if (typeof(window.gtag) !== "undefined"){
    // always track as custom event
    window.gtag('event', eventName, props);

    // also track certain events sa mapped to default events
    const eventMap = {
      'Register': 'StartTrial',
      'PaymentIntent': 'InitiateCheckout',
      'Subscribed': 'Subscribe',
    }
    var gtagEventName = eventMap[eventName];
    
    // customize props/event name for purchases (just made same as meta)
    var gtagProps = {};
    if (gtagEventName === 'Subscribe'){
      if (props.billing_cycle === 'day'){
        gtagEventName = 'Purchase';
        gtagProps = {'value': 10.0, currency: 'USD', transaction_id: ''}
      } else if (props.plan === 'pro'){
        gtagProps = {'value': 118.0, currency: 'USD'}
      } else if (props.plan === 'starter'){
        gtagProps = {'value': 58.0, currency: 'USD'}
      } else if (props.plan === 'mega'){
        gtagProps = {'value': 199.0, currency: 'USD'}
      }
    }
    if (gtagEventName){
      const sentToMap = {
        'StartTrial': 'AW-10893129705/4gv6CIXqtN8ZEOnvn8oo',
        'InitiateCheckout': 'AW-10893129705/pl4ACIjqtN8ZEOnvn8oo',
        'Subscribe': 'AW-10893129705/lnIfCP_ptN8ZEOnvn8oo',
        'Purchase': 'AW-10893129705/l_vrCILqtN8ZEOnvn8oo',
      }
      var sentToEventId = sentToMap[gtagEventName];
      window.gtag('event', 'conversion', Object.assign(gtagProps, {
        'send_to': sentToEventId,
      }));
    }
  }

  // plausible
  if (typeof(window.plausible) !== "undefined"){
    window.plausible(eventName, {
      'props': props
      // callback: () => console.info('Sent event'),
    });
  }

  // posthog
  if (typeof(window.posthog) !== "undefined"){
    window.posthog.capture(eventName, {
      'props': props
    });
  }

  // datafast
  if (typeof(window.datafast) !== "undefined"){
    window.datafast(eventName, props);
  }

  // linkedin
  if (typeof(window.lintrk) !== "undefined"){
    // track certain events based on mapping
    const linkedInEventMap = {
      'Subscribed': '22758738',
    }
    var linkedinEventId = linkedInEventMap[eventName];
    if (linkedinEventId){
      window.lintrk('track', { conversion_id: linkedinEventId });
    }
  }

  // meta
  if (typeof(window.fbq) !== "undefined"){
    // always track as custom event
    window.fbq('trackCustom', eventName, props);

    // also track certain events based on mapping
    const eventMap = {
      'Register': 'StartTrial',
      'PaymentIntent': 'InitiateCheckout',
      'Subscribed': 'Subscribe',
    }
    var metaEventName = eventMap[eventName];
    
    // customize props/event name for purchases
    var metaProps = {};
    if (metaEventName === 'Subscribe'){
      if (props.billing_cycle === 'day'){
        metaEventName = 'Purchase';
        metaProps = {'value': '10.00', currency: 'USD'}
      } else if (props.plan === 'pro'){
        metaProps = {'value': '108.00', currency: 'USD', predicted_ltv: '0.00'}
      } else if (props.plan === 'starter'){
        metaProps = {'value': '58.00', currency: 'USD', predicted_ltv: '0.00'}
      } else if (props.plan === 'mega'){
        metaProps = {'value': '398.00', currency: 'USD', predicted_ltv: '0.00'}
      }
    }
    if (metaEventName){
      window.fbq('track', metaEventName, metaProps);
    }
  }
}

// identify user to fullstory
const identifyUser = (userConfig, additionalProps = {}) => {

  if ((typeof(window.posthog) !== "undefined") && userConfig){
    const userId = `${userConfig.env.name}-${userConfig.identity.id}`
    window.posthog.identify(
      userId,  // Replace 'distinct_id' with your user's unique identifier
      Object.assign({
        email: userConfig.identity.email,
        environment: userConfig.env.name,
        objective: userConfig.profile.objective,
        subscription: userConfig.subscription && userConfig.subscription.key,
        billing_cycle: userConfig.subscription && userConfig.subscription.billing_cycle,
        login_days: userConfig.identity.login_days,
        is_new: userConfig.identity.is_new,
      }, additionalProps),
    );
  }
}

const deidentifyUser = () => {
  // not needed anymore since no more FS
}

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null; // Return null if the cookie is not found
}

export {
    trackEvent,
    identifyUser,
    deidentifyUser,
    getCookie,
}